import { useState } from "react";

import {
  User,
  CreateUserContext,
  initialUserValues,
} from "./components/create-user/CreateUserContext";
import { CreateUserDetailsStep } from "./components/create-user/CreateUserDetailsStep";
import { CreateUserGroupsStep } from "./components/create-user/CreateUserGroupsStep";

export function CreateUser() {
  const [user, setUser] = useState<User>(initialUserValues);
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    <CreateUserDetailsStep key="CreateUserDetailsStep" />,
    <CreateUserGroupsStep key="CreateUserGroupsStep" />,
  ];

  const handleNext = () => {
    setCurrentStep((curr) => curr + 1);
  };

  const handlePrev = () => {
    setCurrentStep((curr) => curr - 1);
  };

  return (
    <CreateUserContext.Provider
      value={{
        user,
        setUser,
        goToNextStep: handleNext,
        goToPrevStep: handlePrev,
        currentStep,
      }}
    >
      {steps[currentStep]}
    </CreateUserContext.Provider>
  );
}
